import React from 'react';

const FindReplaceModal = ({
  isOpen,
  onClose,
  findText,
  setFindText,
  replaceText,
  setReplaceText,
  onPerformFind,
  onPerformReplace,
  onPerformReplaceAll
}) => {
  if (!isOpen) return null;

  const handleClose = () => {
    onClose();
    setFindText("");
    setReplaceText("");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h3 className="text-lg font-semibold mb-4">Find & Replace</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Find
            </label>
            <input
              type="text"
              placeholder="Enter text to find"
              value={findText}
              onChange={(e) => setFindText(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              autoFocus
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Replace with
            </label>
            <input
              type="text"
              placeholder="Enter replacement text"
              value={replaceText}
              onChange={(e) => setReplaceText(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        <div className="flex justify-between mt-6">
          <div className="flex gap-2">
            <button
              onClick={onPerformFind}
              className="px-3 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors text-sm"
              disabled={!findText}
            >
              Find
            </button>
            <button
              onClick={onPerformReplace}
              className="px-3 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 transition-colors text-sm"
              disabled={!findText || !replaceText}
            >
              Replace
            </button>
            <button
              onClick={onPerformReplaceAll}
              className="px-3 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors text-sm"
              disabled={!findText || !replaceText}
            >
              Replace All
            </button>
          </div>
          <button
            onClick={handleClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default FindReplaceModal;